export default "__VITE_ASSET__105b6d15__"